import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { LOG_IN_LABEL, REGISTER_LABEL } from './crown-account-status.copy.js';
import css_248z from './crown-account-status.scss.js';

class CrownAccountStatus extends s {
    constructor() {
        super(...arguments);
        // Only an explicit "true" signs the visitor in: a missing, misspelled or malformed attribute
        // has to render the anonymous state, never the account one.
        this.isAuthenticated = false;
        // Trimmed at the boundary, and null when the attribute is removed becomes '': the render
        // path treats it as a plain string.
        this.displayName = '';
        this.accountUrl = '';
        this.loginUrl = '';
        /** Empty in a market whose configuration has no self-registration, which drops the link. */
        this.registerUrl = '';
        // Configured on the market's account portal page. An untranslated market sends nothing and
        // keeps the English copy, rather than rendering an entry with no label.
        this.loginLabel = LOG_IN_LABEL;
        this.registerLabel = REGISTER_LABEL;
    }
    // Without a name there is nothing to identify the visitor by, and a generic "My profile" is
    // not wanted in the Crown, so the entry is dropped rather than labelled.
    renderSignedIn() {
        if (!this.accountUrl || !this.displayName)
            return w;
        return $ `<a class="entry" href="${this.accountUrl}"><span class="icon" aria-hidden="true">person</span> <span class="label name">${this.displayName}</span></a>`;
    }
    renderRegister() {
        if (!this.registerUrl)
            return w;
        return $ `<a class="entry" href="${this.registerUrl}"><span class="label">${this.registerLabel || REGISTER_LABEL}</span></a>`;
    }
    renderSignedOut() {
        if (!this.loginUrl)
            return w;
        return $ `<a class="entry" href="${this.loginUrl}"><span class="label">${this.loginLabel || LOG_IN_LABEL}</span></a> ${this.renderRegister()}`;
    }
    render() {
        const entries = this.isAuthenticated
            ? this.renderSignedIn()
            : this.renderSignedOut();
        // Without a URL to point at there is nothing to show, and an empty group would still paint
        // the divider against the market links.
        return entries === w
            ? w
            : $ `<div class="group">${entries}</div>`;
    }
}
CrownAccountStatus.styles = css_248z;
__decorate([
    e({
        attribute: 'is-authenticated',
        converter: value => (value === null || value === void 0 ? void 0 : value.trim().toLowerCase()) === 'true',
    })
], CrownAccountStatus.prototype, "isAuthenticated", void 0);
__decorate([
    e({
        attribute: 'display-name',
        converter: value => { var _a; return (_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : ''; },
    })
], CrownAccountStatus.prototype, "displayName", void 0);
__decorate([
    e({ attribute: 'account-url' })
], CrownAccountStatus.prototype, "accountUrl", void 0);
__decorate([
    e({ attribute: 'login-url' })
], CrownAccountStatus.prototype, "loginUrl", void 0);
__decorate([
    e({ attribute: 'register-url' })
], CrownAccountStatus.prototype, "registerUrl", void 0);
__decorate([
    e({ attribute: 'login-label' })
], CrownAccountStatus.prototype, "loginLabel", void 0);
__decorate([
    e({ attribute: 'register-label' })
], CrownAccountStatus.prototype, "registerLabel", void 0);
customElements.define('crown-account-status', CrownAccountStatus);

export { CrownAccountStatus };
